import React, { useContext, useState, useEffect } from "react";
import { Modal, Button, TextInput, Label } from "flowbite-react";
import Swal from "sweetalert2";
import axios from "axios";
import DataTable from "react-data-table-component";
import GlobalContext from "../connections/GlobalContext";
import Head_data from "../components/Head_data";
import Button_submit from "../components/Button_submit";
import engineGif from "../image/engine.gif";

const Branch = ({ theme }) => {
    const { globalValue } = useContext(GlobalContext);
    const [branches, setBranches] = useState([]);
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState("add");
    const [branchName, setBranchName] = useState("");
    const [address, setAddress] = useState("");
    const [gstNo, setGstNo] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [mobileNoWarning, setMobileNoWarning] = useState("");
    const [c_branch_id, setC_branch_id] = useState("");
    const [gstError, setGstError] = useState("");


    const [searchTerm, setSearchTerm] = useState("");
    const [filtered, setFiltered] = useState(branches);


    useEffect(() => {
        const filteredData = branches.filter((branch) =>
            branch[2].toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFiltered(filteredData);
    }, [searchTerm, branches]);




    const [loading, setLoading] = useState(false);

    const fetchData = () => {
        setLoading(true);

        fetch(globalValue + "/branches", {
            method: "GET",
            headers: {
                "x-access-token": sessionStorage.getItem("token"),
            },
        })
            .then((res) => res.json())
            .then((dat) => {
                setBranches(dat);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };



    useEffect(() => {
        fetchData();
    }, [])


    const customStyles = {
        table: {
            style: {
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white", // Table background
                width: "100%",
                border: theme === "dark" ? "solid 1px rgb(63, 62, 62)" : "solid 1px rgb(226, 232, 240)",
            },
        },
        headCells: {
            style: {
                backgroundColor: theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)", // Header background
                color: theme === "dark" ? "white" : "black", // Header text
                fontWeight: "bold",
            },
        },
        cells: {
            style: {
                color: theme === "dark" ? "white" : "black", // Cell text
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
                border: theme === "dark" ? "solid 1px rgb(63, 62, 62)" : "solid 1px rgb(255, 255, 255)", // Cell background
            },
        },
        pagination: {
            style: {
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white", // Pagination background
                color: theme === "dark" ? "white" : "black", // Pagination text
                borderTop: theme === "dark" ? "solid 1px white" : "solid 1px rgb(226, 232, 240)", // Top border for pagination
            },
            pageButtonsStyle: {
                backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white", // Buttons background
                color: theme === "dark" ? "white" : "black", // Buttons text
                fill: theme === "dark" ? "white" : "black", // Arrow colors
                '&:hover': {
                    backgroundColor: theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)", // Hover effect
                },
            },
        },
    };

    const columns = [
        { name: "Branch ID", selector: row => row[1] },
        { name: "Branch Name", selector: row => row[2] },
        { name: "Address", selector: row => row[3] },
        { name: "GST No", selector: row => row[4] },
        { name: "Mobile No", selector: row => row[5] },
        {
            name: "Action",
            center: true,
            cell: row => (
                <div className="flex gap-4">
                    <button
                        onClick={() => handleEditBranch(row)}
                        className="p-2 text-white border bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl"
                    >
                        <i className="fa fa-edit"></i>
                    </button>
                    <button
                        onClick={() => { handleDeleteBranch(row[1]); }}
                        className="p-2 text-white border bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl"
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
            ),
        },
    ];

    const handleBranchNameChange = (e) => {
        setBranchName(e.target.value);
    };

    const handleAddressChange = (e) => {
        setAddress(e.target.value);
    };

    const handleGstNoChange = (e) => {
        const value = e.target.value.toUpperCase();
        setGstNo(value);


        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9][A-Z][0-9A-Z]$/;

        if (value === "" || gstRegex.test(value)) {
            setGstError("");
        } else {
            setGstError("Invalid GST Number. Format: 22AAAAA0000A1Z5");
        }
    };

    const handleMobileNoChange = (e) => {
        const value = e.target.value;
        setMobileNo(value);

        if (!/^[0-9]{0,10}$/.test(value)) {
            setMobileNoWarning("Mobile No must be numeric and up to 10 digits");
        } else if (value.length === 10) {
            setMobileNoWarning("Valid mobile number");
        } else {
            setMobileNoWarning("Incomplete mobile number");
        }
    };

    const handleSubmit = async () => {
        if (!branchName || !address || !gstNo || !mobileNo) {
            Swal.fire("Error", "All fields are required", "error");
            return;
        }

        if (mobileNoWarning && mobileNoWarning !== "Valid mobile number") {
            Swal.fire("Error", mobileNoWarning, "error");
            return;
        }


        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9][A-Z][0-9A-Z]$/;

        if (!gstNo || !gstRegex.test(gstNo)) {
            Swal.fire("Error", "Invalid GST Number. Format: 22AAAAA0000A1Z5", "error");
            return;
        }


        setLoading(true);

        try {
            const branchData = {
                branchName,
                address,
                gstNo,
                mobileNo,
                id: sessionStorage.getItem("name"),
            };

            let response;
            if (mode === "add") {
                response = await axios.post(
                    `${globalValue}/add_branch`,
                    { branchData },
                    {
                        headers: {
                            "x-access-token": sessionStorage.getItem("token"),
                        },
                    }
                );
            } else {
                response = await axios.post(
                    `${globalValue}/edit_branch`,
                    { branchData, branch_id: c_branch_id },
                    {
                        headers: {
                            "x-access-token": sessionStorage.getItem("token"),
                        },
                    }
                );
            }

            if (response.data === "success") {
                Swal.fire(
                    "Success",
                    mode === "add" ? "Branch added successfully" : "Branch updated successfully",
                    "success"
                );
                fetchData();
            } else {
                Swal.fire(
                    "Failure",
                    mode === "add" ? response.data.message : response.data.message,
                    "warning"
                );
            }

            setOpen(false);
            resetForm();
        } catch (error) {
            console.error("Error:", error);
            Swal.fire("Error", "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleEditBranch = (row) => {
        setC_branch_id(row[1]);
        setBranchName(row[2]);
        setAddress(row[3]);
        setGstNo(row[4]);
        setMobileNo(row[5]);
        setMode("edit");
        setOpen(true);
    };

    const handleDeleteBranch = async (id, setLoading) => {
        if (!id) {
            Swal.fire("Error", "Invalid branch ID", "error");
            return;
        }

        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "This will permanently delete the branch!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "Cancel",
            });

            if (result.isConfirmed) {


                const response = await axios.post(
                    `${globalValue}/delete_branch`,
                    {
                        branch_id: id,
                        staff_id: sessionStorage.getItem("name"),
                        position: sessionStorage.getItem("position"),
                    },
                    {
                        headers: {
                            "x-access-token": sessionStorage.getItem("token"),
                        },
                    }
                );



                if (response.data === "success") {
                    Swal.fire("Success", "Branch deleted successfully", "success").then(() => {
                        fetchData();
                    });
                } else {
                    Swal.fire("Failure", response.data.message || "Branch not deleted", "warning");
                }
            }
        } catch (error) {
            setLoading(false);
            console.error("Error:", error);
            Swal.fire("Error", "Something went wrong. Please try again.", "error");
        }
    };


    const resetForm = () => {
        setBranchName("");
        setAddress("");
        setGstNo("");
        setMobileNo("");
        setMobileNoWarning("");
    };

    useEffect(() => {
        if (mode === "add") {
            resetForm();
        }
    }, [mode]);


    return (
        <div>
            {loading && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
                    <img src={engineGif} alt="Loading..." className="w-24 h-24" />
                </div>
            )}
            <Modal
                show={open}
                onClose={() => setOpen(false)}

            >
                <Modal.Header className="bg-white text-gray-900 border-b border-gray-200">
                    {mode === "add" ? "Add Branch" : "Edit Branch"}
                </Modal.Header>

                <Modal.Body className="bg-white text-gray-900 p-6">
                    <form>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {[
                                { id: "branchName", label: "Branch Name", value: branchName, onChange: handleBranchNameChange },
                                { id: "address", label: "Address", value: address, onChange: handleAddressChange },
                                { id: "gstNo", label: "GST No", value: gstNo, onChange: handleGstNoChange },
                            ].map((field) => (
                                <div key={field.id} className="mb-4 bg-white">
                                    <Label htmlFor={field.id} value={field.label} />
                                    <TextInput
                                        id={field.id}
                                        name={field.id}
                                        placeholder={`Enter ${field.label}`}
                                        value={field.value}
                                        onChange={field.onChange}
                                        required
                                        color="white"
                                    />
                                    {field.id === "gstNo" && gstError && (
                                        <p style={{ color: "red", fontSize: "14px" }}>{gstError}</p>
                                    )}
                                </div>
                            ))}
                            <div className="mb-4">
                                <Label htmlFor="mobileNo" value="Mobile No" />
                                <TextInput
                                    id="mobileNo"
                                    name="mobileNo"
                                    type="number"
                                    min="0"
                                    placeholder="Enter Mobile No"
                                    value={mobileNo}
                                    onChange={handleMobileNoChange}
                                    required
                                    color="white"
                                />
                                {mobileNoWarning && (
                                    <p className={`text-sm ${mobileNoWarning === "Valid mobile number" ? "text-green-500" : "text-red-500"}`}>
                                        {mobileNoWarning}
                                    </p>
                                )}
                            </div>
                        </div>
                    </form>
                </Modal.Body>

                <Modal.Footer className="bg-white">
                    <Button
                        onClick={handleSubmit}
                        data={`${mode === "add" ? "Submit" : "Update"}`}
                        type="submit"
                        className="ms-auto"
                    >
                        {mode === "add" ? "Submit" : "Update"}
                    </Button>
                </Modal.Footer>
            </Modal>
            <div
                className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border ${theme === "dark" ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-800"
                    }`}
            >
                <div
                    className={`w-[95%] md:w-[98%] h-[95%] px-4 py-2 rounded-xl shadow-xl overflow-auto ${theme === "dark" ? "bg-gray-800 text-gray-200" : "bg-white text-gray-800"
                        }`}
                >
                    <div className="w-full flex justify-between text-gray-600">
                        <Head_data data="Manage Branch" font="" size="3xl" color={theme === "dark" ? "text-gray-200" : "text-gray-800"} />
                        <button
                            onClick={() => {
                                setMode("add");
                                setOpen(true);
                                resetForm();
                                setBranchName("");
                                setAddress("");
                                setGstNo("");
                                setMobileNo("");
                                setGstError("");
                                setMobileNoWarning("");
                            }}
                            className="px-4 py-2 mt-4 text-white bg-blue-600 rounded hover:bg-blue-700 md:mt-2"
                        >
                            Add Branch
                        </button>
                    </div>
                    <input
                        type="text"
                        placeholder="Search branch by name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full md:w-1/3 px-4 my-2 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                    />

                    <div className="py-6">
                        <DataTable
                            columns={columns}
                            data={filtered}
                            customStyles={customStyles}
                            pagination
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Branch;
